import React from 'react';
import { ArrowRight, Building } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const ExampleScenario = ({ onSelect, exampleScenarioRef, selectButtonRef }) => {
  const { t } = useTranslation();

  const exampleScenario = {
    id: 'example-scenario',
    name: t('example.scenario.name'),
    description: t('example.scenario.description'),
  };

  const handleSelect = () => {
    sessionStorage.setItem('exampleScenario', JSON.stringify(exampleScenario));
    
    onSelect(exampleScenario);
  };

  return (
    <div className="bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 ease-in-out w-96">
      <div className="p-6" ref={exampleScenarioRef}>
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center space-x-4">
            <div className="bg-indigo-100 p-3 rounded-full">
              <Building className="w-6 h-6 text-indigo-600" />
            </div>
            <div>
              <h3 className="text-lg font-bold text-gray-900">{exampleScenario.name}</h3>
            </div>
          </div>
        </div>
        
        <p className="text-gray-600 text-sm mb-6">{exampleScenario.description}</p>
        
        <button
          ref={selectButtonRef}
          onClick={handleSelect}
          className="w-full py-2 px-4 bg-indigo-100 text-indigo-700 hover:bg-indigo-200 rounded-lg flex items-center justify-center gap-2 transition-colors"
        >
          {t('example.scenario.select')}
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default ExampleScenario;